import { useState } from 'react';
import ReactHowler from 'react-howler';
import { animated, useSpring } from '@react-spring/three';
import { Html } from '@react-three/drei';
import {
  EffectComposer, Outline,
  Select, Selection,
} from '@react-three/postprocessing';
import PropTypes from 'prop-types';

import click from '../../../assets/audio/clickEffect.mp3';

import ButtonStartModel from './models/ButtonStartModel';

function ButtonStart({ setShow, changeLoading, canClick }) {
  const [active, setActive] = useState(false);
  const [play, setPlay] = useState(false);
  const [hovered, setHovered] = useState(null);

  const { scale } = useSpring({ scale: active ? 1.2 : 1 });
  const { position } = useSpring({
    to: {
      position: -3,
    },
    from: { position: -30 },
    config: {
      mass: 2, tension: 43, friction: 10, precision: 0.02,
    },
  });
  const handlePlay = () => {
    setPlay(true);
    setShow();
    changeLoading();
  };
  const handleLeavePointer = () => {
    setPlay(false);
    setActive(false);
    setHovered(false);
  };
  const handleOverPointer = () => {
    setActive(true);
    setHovered(true);
  };
  return (
    <mesh>
      <Html><ReactHowler src={click} playing={play} /></Html>
      <Selection>
        <EffectComposer multisampling={8} autoClear={false}>
          <Outline blur visibleEdgeColor="white" edgeStrength={300} width={1000} />
        </EffectComposer>
        <Select enabled={hovered}>
          <animated.mesh
            position={position}
            scale={scale}
            onClick={canClick === false ? handlePlay : null}
            onPointerOver={canClick === false ? handleOverPointer : null}
            onPointerLeave={canClick === false ? handleLeavePointer : null}
          >
            <ButtonStartModel />
          </animated.mesh>
        </Select>
      </Selection>
    </mesh>
  );
}

export default ButtonStart;

ButtonStart.propTypes = {
  setShow: PropTypes.func.isRequired,
  changeLoading: PropTypes.func.isRequired,
  canClick: PropTypes.bool.isRequired,
};
